import { render, staticRenderFns } from "./vue-simple-context-menu.vue?vue&type=template&id=8a2e6cea"
import script from "./vue-simple-context-menu.vue?vue&type=script&lang=js"
export * from "./vue-simple-context-menu.vue?vue&type=script&lang=js"
import style0 from "./vue-simple-context-menu.vue?vue&type=style&index=0&id=8a2e6cea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports